module.exports = __webpack_public_path__ + "img/timeline-16.9e0d77eb.svg";